<template>
  <footer class="p-4 pt-48 flex flex-wrap lg:flex-nowrap leading-tight">
    <div class="pr-8 w-full lg:w-auto mb-4 lg:mb-0">
      <img class="h-8 lg:h-14" alt="Koivu Logo" src="@/assets/koivu-logo.svg" />
    </div>
    <div class="pr-16">
      <a href="https://instagram.com/koivu.it/" rel="noreferrer" target="_blank"
        >@koivu</a
      ><br />
      <a href="mailto:info@koivu.it" class="blank">info@koivu.it</a>
    </div>
    <div class="leading-tight pr-16">
      <router-link :to="{ name: 'cart' }">Cart</router-link><br />
      <router-link :to="{ name: 'privacy' }">Privacy Policy</router-link><br />
      <router-link :to="{ name: 'imprint' }">Imprint</router-link>
    </div>
    <div class="leading-tight pr-16">
      <router-link :to="{ name: 'returns' }">Returns & Refunds</router-link
      ><br />
      <router-link :to="{ name: 'sizing' }">Fit & Size</router-link><br />
      <router-link :to="{ name: 'care' }">Care Instructions</router-link><br />
    </div>
    <div class="mt-4 lg:mt-0 w-full lg:w-auto flex flex-col justify-start">
      <div v-if="!success">
        <div class="mb-2">Subscribe to our newsletter</div>
        <div class="btn-container self-start">
          <input
            class="btn input border-0 text-left"
            type="email"
            name="email"
            v-model="email"
            placeholder="Email"
          />
          <div @click="subscribe" class="w-auto btn action">Subscribe</div>
        </div>
      </div>
      <div class="" v-if="success">Thank you for subscribing</div>
      <div class="mt-2" v-if="error">An error occured. Please try again.</div>
    </div>
  </footer>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      email: null,
      error: false,
      success: false,
    };
  },
  methods: {
    subscribe() {
      if (this.email) {
        axios
          .post(
            "/api/subscribe",
            {
              email: this.email,
            },
            {
              auth: {
                username: process.env.VUE_APP_USERNAME,
                password: process.env.VUE_APP_PASSWORD,
              },
            }
          )
          .then(() => {
            this.success = true;
            this.error = false;
          })
          .catch(() => {
            this.error = true;
          });
      }
    },
  },
};
</script>
